export default `blog-toc-title = 목차
`;